const PageBoundary = () => {
  return (
    <div>
      <div>Sorry, an unexpected error has occurred.</div>
      <div>
        <i>refresh the page</i>
      </div>
    </div>
  )
}

export default PageBoundary
